import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { createReducer, on } from '@ordersnproducts/utils/create-reducer';
import { CxProductType } from '../../models/product-type';
import CxProductTypeActions from '../actions/cx-product-type.actions';

export type CxProductTypeEntity = CxProductType;
export interface CxProductTypeState extends EntityState<CxProductTypeEntity> {
  activeEntityId: string;
}

export const entityAdapter = createEntityAdapter<CxProductTypeEntity>({
  selectId: ({ productTypeId }) => `${productTypeId}`,
});

export const initialCxProductTypeState = entityAdapter.getInitialState({
  activeEntityId: null,
});

export const cxProductTypeReducer = createReducer(
  initialCxProductTypeState,

  on(CxProductTypeActions.selectEntity, (state, { id: activeEntityId }) => {
    return {
      ...state,
      activeEntityId,
    };
  }),

  on(CxProductTypeActions.updateEntity, (state, { payload }) => entityAdapter.upsertOne(payload, state)),
  on(CxProductTypeActions.updateEntities, (state, { payload }) => entityAdapter.upsertMany(payload, state)),
);

export function reducer(state: CxProductTypeState, action: Action) {
  return cxProductTypeReducer(state, action);
}

export const selectActiveEntityId = (state: CxProductTypeState) => state.activeEntityId;
export const { selectIds, selectEntities, selectAll, selectTotal } = entityAdapter.getSelectors();
